import { render } from "./Background.html?vue&type=template&id=2f0cce7e&scoped=true&ts=true&external"
import script from "./Background.ts?vue&type=script&lang=ts&external"
export * from "./Background.ts?vue&type=script&lang=ts&external"

import "./Background.scss?vue&type=style&index=0&id=2f0cce7e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0cce7e"]])

export default __exports__